
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type garageRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function garageRT(): TemplateResult<garageRTRootProps> {
    return _createElement('div', { 'className': 'cm_garage' }, _createElement('a', {
        'className': 'cm_toggle-dropdown garage-button',
        'title': 'Garage: ' + this.size + ' item(s)',
        'tabIndex': '0',
        'role': 'button'
    }, _createElement('div', { 'className': 'garage-icon-container' }, _createElement('div', { 'className': 'garage-icon cm_icon_garage__background' }), this.size ? _createElement('span', {
        'className': 'garage-size header__cart-count',
        'key': '228'
    }, this.size) : null), _createElement('span', { 'className': 'garage-label' }, _translate(`garage_title`))), [this.garageDropdown(function () {
            function repeatItems1(items, itemsIndex) {
                return [items(function () {
                        return _createElement('div', { 'className': 'garage-item' + (this.isSelected ? ' garage-item-selected' : '') }, _createElement('span', {
                            'className': 'select-model',
                            'onClick': this.selectVehicle
                        }, _createElement('div', { 'className': 'circle-model' }), '\n          ', this.vehicleString), _createElement('span', {
                            'className': 'remove-model',
                            'onClick': this.removeVehicle
                        }, [_createElement('svg', {
                                'className': 'cm_icon cm_icon-times',
                                'height': '20px',
                                'role': 'img',
                                'viewBox': '0 0 22 22',
                                'key': '2990'
                            }, _createElement('path', { 'd': 'M1,1L21,21M21,1L1,21' }))]));
                    }, { count: undefined })];
            }
            return _createElement('div', { 'className': 'cm_garageDropdown' }, this.template === 'list' ? _createElement('div', {
                'className': 'cmTemplate_list',
                'key': '31'
            }, _createElement('div', { 'className': 'garage-content' }, _createElement('div', { 'className': 'garage-header' }, _createElement('div', { 'className': 'garage-title' }, 'MY GARAGE'), _createElement('div', {
                'className': 'garage-close',
                'onClick': () => this.closeGarage()
            }, [_createElement('svg', {
                    'className': 'cm_icon cm_icon-times',
                    'height': '20px',
                    'role': 'img',
                    'viewBox': '0 0 22 22',
                    'key': '2870'
                }, _createElement('path', { 'd': 'M1,1L21,21M21,1L1,21' }))])), _createElement('hr', {}), _createElement.apply(this, [
                'div',
                { 'className': 'garage-vehicles cmRepeater_items' },
                _map(this.items, repeatItems1.bind(this))
            ]), _createElement('div', { 'className': 'garage-footer' }, [this.addButton(function () {
                    return _createElement('div', { 'className': 'add-vehicle  btn cm_btn--primary cm_addButton' }, window.Convermax.config?.garageButtonText || _translate(`garage_add_button`));
                }, {
                    widgetName: 'undefined',
                    items: undefined
                })], _createElement('a', {
                'className': 'btn cm_btn--primary garage-shop-now',
                'onClick': () => this.closeGarage(),
                'href': window.Convermax.Shopify.getCollectionsPageUrl() + '/tires'
            }, 'Shop Now'), _createElement('div', {
                'className': 'clear-garage',
                'onClick': this.clearGarage
            }, _translate(`garage_clear`))))) : null, this.template === 'empty' ? _createElement('div', {
                'className': 'cmTemplate_empty',
                'key': '2135'
            }, _createElement('div', { 'className': 'garage-content' }, [this.vehicleWidget(function () {
                    function repeatSelects1(selects, selectsIndex) {
                        return [selects(function () {
                                function repeatEntry1(popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                                    return _createElement('option', {
                                        'disabled': this.loading,
                                        'value': entry.term,
                                        'key': entry.value
                                    }, '\n            ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n          ');
                                }
                                function repeatEntry2(popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                                    return _createElement('option', {
                                        'disabled': this.loading,
                                        'value': entry.term,
                                        'key': entry.value
                                    }, '\n          ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n        ');
                                }
                                function scopePopularEntriesUnpopularEntriesIsPopularField3() {
                                    var popularEntries = this.entries.filter(entry => entry.payload === 'Popular');
                                    var unpopularEntries = this.entries.filter(entry => entry.payload !== 'Popular');
                                    var isPopularField = popularEntries.length && unpopularEntries.length;
                                    return [
                                        !(this.hideNullOption && this.entries.some(e => e.selected)) ? _createElement('option', {
                                            'value': '',
                                            'key': 'null-option'
                                        }, '\n          ', _translate(`select_title`), ' ', this.title, '\n        ') : null,
                                        this.loading ? _createElement('option', {
                                            'key': 'loading-option',
                                            'disabled': true
                                        }, _translate(`select_loading`)) : null,
                                        isPopularField ? [
                                            _createElement('option', {
                                                'className': 'cm_option_title cm_option-popular',
                                                'disabled': true,
                                                'key': '11021'
                                            }, _translate(`ymm_bar_popular`)),
                                            _map(popularEntries, repeatEntry1.bind(this, popularEntries, unpopularEntries, isPopularField)),
                                            _createElement('option', {
                                                'className': 'cm_option_title cm_option-unpopular',
                                                'disabled': true,
                                                'key': '11024'
                                            }, _translate(`ymm_bar_unpopular`))
                                        ] : null,
                                        _map(isPopularField ? unpopularEntries : this.entries, repeatEntry2.bind(this, popularEntries, unpopularEntries, isPopularField))
                                    ];
                                }
                                function scopeShowSelectedValues4() {
                                    var showSelectedValues = this.selectedEntries.length;
                                    return _createElement('option', {
                                        'key': '_current',
                                        'value': '_current'
                                    }, showSelectedValues ? [this.selectedEntries.map(e => e.value).join(', ')] : null, !showSelectedValues ? [
                                        _translate(`select_title`),
                                        ' ',
                                        this.title
                                    ] : null);
                                }
                                function repeatEntry5(entry, index) {
                                    return _createElement('div', {
                                        'className': 'option' + (this.isSearchable && this.activeIndex === index || !this.isSearchable && entry.selected ? ' cm_checked' : ''),
                                        'key': entry.value,
                                        'onClick': () => this.onChange(entry.term)
                                    }, this.showCheckboxes ? _createElement('input', {
                                        'type': 'checkbox',
                                        'readOnly': true,
                                        'checked': entry.selected,
                                        'className': 'cm_dropdown_checkbox cm_facet_checkbox',
                                        'key': '3330'
                                    }) : null, _createElement('div', { 'className': 'cm_dropdown_value' }, entry.value), this.showHitCount ? _createElement('div', {
                                        'className': 'cm_dropdown_hitCount',
                                        'key': '3532'
                                    }, entry.hitCount) : null);
                                }
                                return _createElement('div', { 'className': this.extraClassName }, !this.isSearchable ? _createElement('div', {
                                    'className': 'cm_select_toggle' + (this.useNativeDropdown ? ' cm_select_toggle__native' : '') + ' cm_toggle-dropdown',
                                    'key': '39'
                                }, _createElement('select', {
                                    'className': 'cm_select_inner-select cm_select__pretty',
                                    'onChange': this.onChange,
                                    'value': this.useNativeDropdown ? this.firstSelectedTerm || '' : '_current',
                                    'disabled': this.disabled,
                                    'aria-label': this.title
                                }, this.useNativeDropdown ? scopePopularEntriesUnpopularEntriesIsPopularField3.apply(this, []) : null, !this.useNativeDropdown ? scopeShowSelectedValues4.apply(this, []) : null)) : null, this.isSearchable ? [[this.filterInput(function () {
                                            return _createElement('div', { 'className': 'input cm_filterInput' });
                                        }, {
                                            widgetName: 'undefined',
                                            items: undefined
                                        })]] : null, !this.disabled && !this.useNativeDropdown ? _createElement.apply(this, [
                                    'div',
                                    {
                                        'className': 'cm_dropdown cm_select_dropdown cm_hide',
                                        'aria-label': this.title,
                                        'key': '2592'
                                    },
                                    !this.hideNullOption ? _createElement('div', {
                                        'className': 'option',
                                        'key': 'null-option',
                                        'onClick': () => this.onChange('')
                                    }, '\n      ', _translate(`select_title`), ' ', this.title, '\n    ') : null,
                                    this.loading ? _createElement('div', {
                                        'className': 'option',
                                        'key': 'null-option',
                                        'disabled': true
                                    }, _translate(`select_loading`)) : null,
                                    !this.loading ? _map(this.entries, repeatEntry5.bind(this)) : null
                                ]) : null);
                            }, { count: undefined })];
                    }
                    return _createElement('div', { 'className': 'cm_vehicle-widget cm_vehicle-widget__garage cm_vehicleWidget' }, _createElement('div', { 'className': 'cm_vehicle-widget_dropdowns' }, _createElement('div', { 'className': 'cm_vehicle-widget_body' }, _createElement.apply(this, [
                        'div',
                        { 'className': 'cm_vehicle-widget_select-container  cmRepeater_selects' },
                        _map(this.selects, repeatSelects1.bind(this))
                    ]), _createElement('div', { 'className': 'cm_vehicle-widget_button-container' }, _createElement('div', {
                        'className': 'cm_vehicle-widget_button cm_vehicle-widget_button__go btn cm_btn--primary',
                        'onClick': this.selectVehicle,
                        'disabled': !this.allowToSetVehicle,
                        'role': 'button',
                        'tabIndex': this.allowToSetVehicle ? '0' : '-1'
                    }, '\n    ', _translate(`ymm_bar_submit`), '\n  '), _createElement('div', {
                        'className': 'cm_vehicle-widget_button cm_vehicle-widget_button__clear btn cm_btn--secondary',
                        'onClick': this.discardVehicle,
                        'disabled': !this.allowToDiscardVehicle,
                        'role': 'button',
                        'tabIndex': this.allowToDiscardVehicle ? '0' : '-1'
                    }, '\n    ', _translate(`ymm_bar_clear`), '\n  ')))));
                }, {
                    widgetName: 'undefined',
                    items: undefined
                })])) : null);
        }, {
            widgetName: 'undefined',
            items: undefined
        })]);
}
        export const componentNames = ["cm:addButton","cm:filterInput","cm:vehicleWidget","cm:garageDropdown"]